import { render, staticRenderFns } from "./banners-news.vue?vue&type=template&id=6d18af66&scoped=true&"
import script from "./banners-news.vue?vue&type=script&lang=js&"
export * from "./banners-news.vue?vue&type=script&lang=js&"
import style0 from "./banners-news.vue?vue&type=style&index=0&id=6d18af66&scoped=true&lang=css&"
import style1 from "./banners-news.vue?vue&type=style&index=1&id=6d18af66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18af66",
  null
  
)

export default component.exports